var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36 0H4C1.79086 0 0 1.79086 0 4V36C0 38.2091 1.79086 40 4 40H36C38.2091 40 40 38.2091 40 36V4C40 1.79086 38.2091 0 36 0Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5139 8.52768C21.9249 8.6744 22.1993 9.06368 22.1993 9.50008V16.6343H29.3335C29.7324 16.6343 30.0957 16.8641 30.2665 17.2246C30.4373 17.5851 30.3852 18.0118 30.1326 18.3206L19.6326 31.1539C19.3562 31.4917 18.8974 31.6192 18.4863 31.4725C18.0753 31.3258 17.801 30.9365 17.801 30.5001V23.3659H10.6668C10.2678 23.3659 9.90459 23.1361 9.73375 22.7756C9.56291 22.415 9.61505 21.9884 9.86768 21.6796L20.3677 8.84627C20.644 8.5085 21.1029 8.38097 21.5139 8.52768ZM12.8456 21.3009H18.8335C19.4037 21.3009 19.866 21.7632 19.866 22.3334V27.6076L27.1546 18.6993H21.1668C20.5966 18.6993 20.1343 18.237 20.1343 17.6668V12.3925L12.8456 21.3009Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuick);
export default __webpack_public_path__ + "static/media/quick.800e1aafc51b58d5a3e67454f46dacb1.svg";
export { ForwardRef as ReactComponent };